import { busService } from "../bus";
import { AvatarMeshVisibilityMessage, AvatarPeerRoomChangedMessage } from "../../messages/session/PeerMessages";
import { AvatarRenderable } from "./AvatarRenderable";
import { RendererSystem } from "../rendering/renderer/RendererSystem";
export class AvatarSystem extends RendererSystem {
    constructor(renderer) {
        super(renderer, "AvatarSystem");
        this.connection = busService.connection("AvatarSystem");
        this.handleAvatarPeerRoomChangedMessage = (msg) => {
            const model = this.renderer.getModel(msg.uid);
            if (!model)
                return;
            const avatar = model.getRenderableByType(AvatarRenderable);
            if (!avatar)
                return;
            avatar.onPeerRoomChanged(msg.roomDepthDiff, msg.audible);
        };
        this.handleAvatarMeshVisibilityMessage = (msg) => {
            const model = this.renderer.getModel(msg.uid);
            if (!model)
                return;
            const avatar = model.getRenderableByType(AvatarRenderable);
            if (!avatar)
                return;
            avatar.onMeshVisibilityChanged(msg.visibility);
        };
        this.connection.subscribeByType(AvatarPeerRoomChangedMessage, this.handleAvatarPeerRoomChangedMessage);
        this.connection.subscribeByType(AvatarMeshVisibilityMessage, this.handleAvatarMeshVisibilityMessage);
    }
}
